document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('[data-fs-nav-close]');
  if (closeButton) closeButton.closest('details')?.removeAttribute('open');

  const navLink = event.target.closest('.fs-mobile-nav a');
  if (navLink) navLink.closest('details.fs-mobile-menu')?.removeAttribute('open');
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('details.fs-mobile-menu[open]').forEach((menu) => menu.removeAttribute('open'));
});

document.querySelectorAll('.fs-footer__accordion').forEach((accordion) => {
  accordion.addEventListener('toggle', () => {
    if (!accordion.open) return;
    accordion.parentElement.querySelectorAll('.fs-footer__accordion[open]').forEach((other) => {
      if (other !== accordion) other.removeAttribute('open');
    });
  });
});
